
import { defineComponent } from "@vue/runtime-core";
import {onMounted, onUnmounted, ref} from "vue";

export default defineComponent({
  setup(_, { emit }) {
    const pressed = ref(false);
    const moved = ref(false);

    const close = () => {
      if (!moved.value) {
        emit("close-modal");
      }
    };

    const pressing = () => {
      pressed.value = true;
      moved.value = false;
    };
    const moving = () => {
      moved.value = true;
    };

    onMounted(() => {
      document.body.style.overflow = "hidden";
      document.addEventListener("keydown", escClose);
    });

    onUnmounted(() => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", escClose);
    });

    const escClose = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        emit("close-modal");
      }
    };

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        emit("close-modal");
      }
    });
    return {
      pressed,
      pressing,
      moving,
      close,
    };
  },
});
